/* ===========================================================================
 * Rolagem infinita (infinity scroll) — Collection e Search
 * ---------------------------------------------------------------------------
 * Camada em cima da paginação "Carregar mais": um IntersectionObserver aciona
 * automaticamente o botão .js-btn-load-more quando ele entra no viewport. Só há
 * o que observar quando `pagination_style == 'load_more'` (é o único modo que
 * renderiza o <collection-load-more>). O botão segue VISÍVEL como fallback.
 *
 * Chamamos bind() a cada mudança do grid (MutationObserver no
 * #ProductGridContainer). Isso resolve dois pontos:
 *   1. o facets.js re-renderiza o container ao filtrar/ordenar, trocando o
 *      botão por um nó novo — sem re-vincular, o observer ficaria preso ao nó
 *      antigo e a rolagem morreria no primeiro filtro;
 *   2. o IntersectionObserver NÃO re-dispara enquanto o alvo permanece contínuo
 *      no viewport (página curta). Reobservar a cada carga força a reavaliação
 *      da interseção, mantendo o carregamento até o botão sair de vista.
 * Ouvimos também o atributo `disabled` (marcado durante o fetch pelo
 * collection-load-more.js): quando é removido ao fim da carga, reavaliamos para
 * continuar. O próprio `disabled` evita disparo duplo durante o fetch.
 *
 * O sort "Maior desconto" remove a paginação nativa e faz a própria rolagem
 * infinita (discount-sort.js) — nesse caso não observamos o botão nativo.
 * =========================================================================== */

(function () {
  'use strict';

  const DISCOUNT_SORT = 'discount-descending';

  let ioObserver = null;
  let containerObserver = null;

  function currentButton() {
    const discountActive =
      new URLSearchParams(window.location.search).get('sort_by') === DISCOUNT_SORT;
    return discountActive ? null : document.querySelector('.js-btn-load-more');
  }

  function bind() {
    if (ioObserver) ioObserver.disconnect();

    const btn = currentButton();
    if (!btn) return;

    ioObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !entry.target.hasAttribute('disabled')) {
            entry.target.click();
          }
        });
      },
      // Pré-carrega antes de o botão chegar ao viewport (rolagem mais suave).
      { rootMargin: '400px 0px' }
    );
    ioObserver.observe(btn);
  }

  function watchContainer() {
    const container = document.getElementById('ProductGridContainer');
    if (!container) return;
    if (containerObserver) containerObserver.disconnect();
    containerObserver = new MutationObserver(bind);
    containerObserver.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled'],
    });
  }

  function init() {
    bind();
    watchContainer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Editor de temas: a section é re-renderizada por completo.
  document.addEventListener('shopify:section:load', init);
})();
